import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';

// Custom styles for the Backdrop
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 9999,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.3)', // Dimmed transparent background
}));

// Custom CircularProgress styles
const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
    thickness: 5, // Spinner line thickness
    width: '80px !important', // Spinner size
    height: '80px !important', // Spinner size
}));

const BlockingSpinner = ({ open, message = '' }) => {
    return (
        <StyledBackdrop open={open}>
            {message ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        backgroundColor: '#fff',
                        color: '#000',
                        padding: '24px 28px',
                        borderRadius: 4,
                        boxShadow: '0 16px 40px rgba(0,0,0,0.18)',
                        minWidth: { xs: '260px', sm: '320px' },
                        maxWidth: { xs: '90%', sm: '420px' },
                    }}
                >
                    <StyledCircularProgress sx={{ color: '#D81B60' }} />
                    <Typography variant="body1" sx={{ color: '#333', textAlign: 'center' }}>
                        {message}
                    </Typography>
                </Box>
            ) : (
                <StyledCircularProgress />
            )}
        </StyledBackdrop>
    );
};

export default BlockingSpinner;
